/* MAPY cez GoogleMap */
function fire(f) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", f);
  } else {
    f();
  }
}


let map;

// vyznaceny polygon s parkoviskom
function addParking(encoded) {
  var srt1Path = google.maps.geometry.encoding.decodePath(encoded);
  srt1Region = new google.maps.Polygon({
    paths: srt1Path,
    strokeColor: "#7986cb",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "green",
    fillOpacity: 0.225,
    });
  srt1Region.setMap(map);

}

async function initMap() {
  const position = { lat: 48.19286095733476, lng: 17.035550839974068 };
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

  // mapa
  map = new Map(document.getElementById("map"), {
    zoom: 17,
    center: position,
    mapId: "DEMO_MAP_ID", // default pre mapy, ktore nepotrebuju mapId
    mapTypeControl: false,
  });

  // parkoviska (vid https://developers.google.com/maps/documentation/utilities/polylineutility )
  addParking("azceH{a~fBIqAuBt@LzApBs@");
  addParking("yjceH{g~fBGy@e@JKeAVKPf@^MJHRGr@Ql@SLhAm@V}@V@NUFA]G@?J");
  addParking("czceH_~}fBPr@NRrA_@DNj@QMmAeCj@CO");

  // marker
  const markerImg = document.createElement("img");
  markerImg.src = 'img/marker.png';
  markerImg.style.width = '97px';

  const marker = new AdvancedMarkerElement({
    map: map,
    position: position,
    content: markerImg,
    title: "AMI-DENT s.r.o."
  });
}

// nahrat mapu na zaciatku
fire( () => {
(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
  key: "AIzaSyCM4H_IhklI_KQYeeDongSoa8FoV9ZiZ_g",
  v: "weekly",
  libraries:'geometry'
});
initMap();
});


